import { GetStaticProps } from "next";
import React from "react";
import { PAGE_DATA_QUERY } from "page/query";
import { PageData } from "page/types";
import { client } from "../../sanity/client";
import { AgnecesImmobiliere } from "page/AgnecesImmobiliere/AgnecesImmobiliere";
import Head from "next/head";

interface PageProps {
  data: PageData | null;
  preview: boolean;
  slug?: string | null;
  token: string | null;
}

interface Query {
  [key: string]: string;
}

interface PreviewData {
  token?: string;
}

export const getStaticProps: GetStaticProps<
  PageProps,
  Query,
  PreviewData
> = async (ctx) => {
  let { params = {}, preview = false, previewData = {} } = ctx;
  params.slug = "agences-immobiliere";
  if (preview && previewData.token) {
    return {
      props: {
        data: null,
        preview,
        slug: "agences-immobiliere",
        token: previewData.token,
      },
    };
  }

  const data = await client.fetch<PageData | null>(PAGE_DATA_QUERY, params);

  return {
    props: {
      data,
      preview,
      slug: params?.slug.replace("/fr", "").replace("/ar", "") || null,
      token: null,
    },
  };
};

export default function Page(props: PageProps) {
  const { data, slug, token } = props;
  if (data) {
    return (
      <>
        <Head>
          <link
            href="https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.css"
            rel="stylesheet"
          />
          <link
            href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.2.0/mapbox-gl-geocoder.css"
            rel="stylesheet"
          />
        </Head>
        <AgnecesImmobiliere data={data} slug={slug} />
      </>
    );
  }
}
